export default __webpack_public_path__ + "static/media/pause.94b3b031.svg";